import React, { useContext, useState } from "react";
import { Oval } from "react-loader-spinner";
import { useNavigate } from "react-router";
import { useMediaPredicate } from "react-media-hook";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";

import { ContextGlobal } from "../../contexts/ContextGlobal";
import { FormPackageSearch } from "../Forms/FormPackageSearch";
import { DownloadSampleModal } from "../Modals/DownloadSampleModal";

export const ProMCPNew = (props) => {
    const { createRequest } = useContext(ContextGlobal);

    const [loading, setLoading] = useState(false);
    const history = useNavigate();

    const phoneSize = useMediaPredicate("(max-width: 450px)");
    const midSizeScreen = useMediaPredicate("(max-width: 767px)");
    const laptopSize = useMediaPredicate("(max-width: 1536px)");

    return (
        <div className="card card-product-no-height info-card transparent">
            <div className="row g-0">
                {midSizeScreen ? null : (
                    <div className="col-md-4 card-right-left-side">
                        <div className="d-flex flex-column justify-content-center align-items-stretch" style={{ height: "100%" }}>
                            {/* <div className="col-md-12" style={{ textAlign: "center", marginTop: "15px" }}>
                                <span 
                                    className="download-mcp-file-span"
                                    data-bs-toggle="modal" 
                                    data-bs-target="#download-sample-modal"
                                    title="Download Sample"
                                >
                                    <img src="/img/Access_Homepage PMCP Report Image SM.png" className="img-fluid" alt="Responsive image"/>
                                    <FontAwesomeIcon className="hidden_img" icon={faFileDownload}  />
                                </span>
                            </div> */}
                            {/* <h1 className="text-center mb-4" style={{font: "700 50pt Montserrat", color: "#1db8ea"}}>$1,250</h1> */}
                            <div className="row">
                                <div className="col-md-10 offset-md-1">
                                    <div className="text-center">
                                        <button
                                            className="btn access-primary-blue"
                                            data-bs-toggle="modal"
                                            data-bs-target="#download-sample-modal"
                                            title="Download Sample"
                                            style={{ padding: "0.6rem 3.2rem" }}
                                            onClick={(e) => {
                                                // e.stopPropagation();
                                                props.setProduct("type_product_medical_cost_projection_pro");
                                            }}
                                        >
                                            Download Sample
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-10 offset-md-1">
                                    <div className="text-center mt-5">
                                        <button
                                            className="btn access-primary-btn-lg"
                                            onClick={async (e) => {
                                                setLoading(true);
                                                await createRequest("type_product_medical_cost_projection_pro");
                                                setLoading(false);
                                                history("/builder/pro_mcp");
                                            }}
                                        >
                                            {loading ? (
                                                <Oval color="white" height={20} width={20} />
                                            ) : (
                                                <>
                                                    <span>ORDER PRO MCP</span>
                                                    <br />
                                                    <span style={{ fontSize: "12px", fontWeight: "500" }}>Hand it over to the Pros</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-md-8" style={{ padding: "30px" }} /*style={{ paddingRight: phoneSize ? "" : "5%"}}*/>
                    <div className="row">
                        <div className="col-md-12" style={{ marginBottom: "5px" }}>
                            {phoneSize ? (
                                <>
                                    <div className="pro-product-heading text-center">Pro Medical</div>
                                    <div className="pro-product-heading text-center">Cost Projection</div>
                                    <div className="pro-product-heading text-center">$1,250</div>
                                </>
                            ) : (
                                <div className="pro-product-heading">
                                    Pro Medical Cost Projection
                                    <span className="float-end">$1,250</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row g-0">
                                <div className="col-auto" style={{ marginTop: "0px", color: "" }}>
                                    <b>Estimates built by Certified Professional Coders</b>
                                </div>
                            </div>
                            <div className="row g-0">
                                <div className="col-auto mb-3">Not sure what treatment is needed? Leave it to the pros. Send us the doctor's recommendation and we'll take care of the rest.</div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row mb-3">
                        <div className="col-lg-12 col-md-6 col-xs-12">
                            <div
                                className="card card-product"
                                style={{
                                    width: "100%",
                                    borderRadius: "2em",
                                    background: "#fef7c2", // needs to be dynamic - #ce0044 for bad #71e099 for good
                                }}
                            >
                                <div className="card-banner">
                                    <div className="d-flex justify-content-between">
                                        <div
                                            className="notification"
                                            style={{color: "black",}}
                                        >
                                            If you are in need of a Standard please do add in the Your Comments that you require a Standard Report. We will reach out to you to confirm and ask about which procedures you would like to add.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row g-0">
                                <div className="col-auto">
                                    <ul className="pro-product-ul-style">
                                        <li className="product-bullet">Includes pre-op, post-op, and all relevant provider services</li>
                                        <li className="product-bullet">1-step submission, we just need case info and recommendation</li>
                                        <li className="product-bullet">5 business day turnaround</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {midSizeScreen ? (
                        <div className="row">
                            <div className="col-md-4" style={{ paddingBottom: "" }}>
                                <div className="row justify-content-center align-items-center">
                                    <hr style={{ color: "#1db8ea", marginBottom: "20px" }} />
                                    <div className="row" style={{ marginTop: "20px" }}>
                                        <div className="col text-center">
                                            <button
                                                className="btn access-primary-btn-lg"
                                                onClick={async (e) => {
                                                    setLoading(true);
                                                    await createRequest("type_product_medical_cost_projection_pro");
                                                    setLoading(false);
                                                    history("/builder/pro_mcp");
                                                }}
                                            >
                                                {loading ? (
                                                    <Oval color="white" height={20} width={20} />
                                                ) : (
                                                    <>
                                                        <span>ORDER PRO MCP</span>
                                                        <br />
                                                        <span style={{ fontSize: "12px", fontWeight: "500" }}>Hand it over to the Pros</span>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
